import type { FC } from "react";
import { Layout } from "../Layout";
import { AuthForm } from "./AuthForm";

interface Props {
  className?: string;
}

export const LogIn: FC<Props> = () => {
  return (
    <Layout>
      <AuthForm />
    </Layout>
  );
};
